/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { ProtectedRouter } from 'infrastructure/routing';
import { Router, Route } from 'framework/routing';
import ExtensionPageLayout from 'domain/recruiting/candidate/applications/createupdate/Create/layout/ExtensionPageLayout';
import CreateCandidateApplicationFromJobBoardPage from 'domain/recruiting/candidate/applications/createupdate/Create';
import GLOBAL_RECRUITING_APPLICATION_CREATE from './constants';
import { GlobalProtectedRoute } from 'framework/authorization';

const EXTENSION_PATH = '/create-application-from-extension';

const SidepanelExtensionRouter: Router = () => {
  const { isAuthenticated } = useAuthenticationService();
  return (
    <ProtectedRouter basePath={EXTENSION_PATH}>
      <Routes>
        <Route
          path=""
          element={
            <GlobalProtectedRoute globalPermissionToCheck={GLOBAL_RECRUITING_APPLICATION_CREATE}>
              <ExtensionPageLayout>
                <CreateCandidateApplicationFromJobBoardPage showBreadcrumbs={false} />
              </ExtensionPageLayout>
            </GlobalProtectedRoute>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

SidepanelExtensionRouter.getRouterPath = () => `${EXTENSION_PATH}/*`;

export default SidepanelExtensionRouter;
